const config = {
  api_url: 'https://apiv2.simblesense.com/v2.0/',
};

export default config;
